import { PoDialogService, PoNotificationService, PoI18nPipe } from '@po-ui/ng-components';
import { LiteralsService } from './../../../../../shared/services/literals-service';
import { Component, OnInit, Input, OnChanges, Output, EventEmitter, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { AttachmentDocumentsService } from '../../services/attach-documents.service';
import { MingleService } from '@totvs/mingle';
import { Utils } from '../../../../../shared/helper/utils';
import { MenuService } from '../../services/menu.service';
import { LoginService } from '../../../../../shared/services/login.service';
import { TemporaryStorageService } from 'src/app/shared/services/temporary-storage.service';
import { ProtheusBridgeService, ProtheusBridgePayload } from 'src/app/shared/services/protheus-bridge.service';

@Component({
    selector: 'attach-documents',
    templateUrl: './attach-documents.component.html',
    styleUrls: ['./attach-documents.component.css'],
    providers: [PoI18nPipe],
    standalone: false
})
export class AttachDocumentsComponent implements OnInit, OnChanges, OnDestroy {

  @Input('c-attachments') contractAttachments: Array<any>;
  @Input('c-info') contractInfo;
  @Input('c-table') table: string;
  @Input('c-index') index: number = 1; //-- Índice usado no seek do registro âncora no Protheus (banco de conhecimento)
  @Output('c-sucess') uploadSucess = new EventEmitter();

  literals;
  public filesToUpload: Array<any> = [];
  public hasFiles:  number;
  public labelsToUpload: Array<any> = [];
  public disableUpload: boolean = true;
  public disableDelete: boolean = false;
  public isHovering: boolean = false;

  //-- Dentro do Protheus, anexar é apenas uma ação de clique que abre a tela
  //-- nativa do banco de conhecimento. Fora do Protheus, mantém o fluxo web
  //-- (arrastar/selecionar arquivo, upload HTTP, download e exclusão locais).
  public isProtheusAttach: boolean = false;

  constructor(
    public literalsService: LiteralsService,
    private attachDocumentsService: AttachmentDocumentsService,
    private poNotification: PoNotificationService,
    private poI18n: PoI18nPipe,
    private thfDialogService: PoDialogService,
    private mingleService: MingleService,
    private utils: Utils,
    private menuService: MenuService,
    private loginService: LoginService,
    private temporaryStorageService: TemporaryStorageService,
    private protheusBridge: ProtheusBridgeService) {
    this.literals = this.literalsService.getLiterals();
  }

  ngOnInit() {
    const defaultHeaders = this.utils.getHeaders();
    this.mingleService.setDefaultHeaders(defaultHeaders);

    this.isProtheusAttach = this.loginService.isProtheusLogged() && this.temporaryStorageService.getValue('paramAttachDef');

    //-- Quando o pai não fornece a lista via c-attachments, o componente busca
    //-- os anexos já vinculados para exibi-los ao abrir a tela.
    if (!this.contractAttachments) {
      this.loadAttachments();
    }
  }

  ngOnChanges() {
    if (this.contractAttachments) {
      this.labelsToUpload = this.contractAttachments.map((a, index) => ({
        id: index,
        protheusId: a.id,
        name: a.name,
        description: a.description,
        documentKey: a.documentkey,
        type: 'file',
        status: 'exist'
      }));
    }
  }

  ngOnDestroy() { }

  // ------------------------------------------------------------------ //
  // Ação de anexo (ponto de decisão único por ambiente)
  // ------------------------------------------------------------------ //

  //-- Clique na área de anexo. Dentro do Protheus abre o banco de conhecimento;
  //-- fora, abre o seletor de arquivos local (fluxo web original).
  openAttach(): void {
    if (this.isProtheusAttach) {
      this.attachViaProtheus();
    } else {
      this.openFileDialog();
    }
  }

  //-- Abre a tela nativa do banco de conhecimento (jsToAdvpl -> MsDocument) e,
  //-- ao fechar, reconstrói a lista com todos os documentos da entidade.
  //-- Envia apenas o contexto (key/table/index); o executionHash é injetado
  //-- pelo ProtheusBridgeService.
  private attachViaProtheus(): void {
    if (!this.table) {
      this.table = 'DHU';
    }

    this.menuService.loading(true);

    const data = {
      key: this.temporaryStorageService.getValue('quotationCode'),
      table: this.table,
      index: Number(this.index)
    };

    this.protheusBridge.callAndWait('attach', data, {
      onClosed: (payload) => this.onAttachClosed(payload),
      onError: (error) => {
        this.poNotification.error(this.utils.getErrorMessage(error));
        this.menuService.loading(false);
      },
      onFinally: () => this.menuService.loading(false),
    });
  }

  //-- Retorno da tela nativa: o Protheus devolve a lista COMPLETA de documentos
  //-- da entidade, usada para reconstruir a lista exibida.
  private onAttachClosed(payload: ProtheusBridgePayload): void {
    if (!payload['status']) {
      if (payload['message']) {
        this.poNotification.error(payload['message']);
      }
      return;
    }

    const documents: Array<any> = payload['documents'] || [];

    this.labelsToUpload = documents.map((doc, index) => ({
      id: index,
      protheusId: doc.id,
      name: doc.name,
      description: doc.description,
      documentKey: doc.documentKey,
      type: 'file',
      code: 200,
      status: 'exist',
      labelStatus: this.literals?.str0192
    }));

    this.temporaryStorageService.setValue('hasAttachment', !!this.labelsToUpload.length);
    this.uploadSucess.emit();

    if (payload['message']) {
      this.poNotification.success(payload['message']);
    }
  }

  //-- Carrega os anexos já vinculados à entidade para exibi-los ao abrir a tela.
  loadAttachments(): void {
    const key: string = this.temporaryStorageService.getValue('quotationCode');

    if (!key) {
      return;
    }

    this.menuService.loading(true);

    this.attachDocumentsService.getAttachmentsList(1, 9999, key)
      .subscribe({
        next: (value) => {
          this.labelsToUpload = (value?.items || []).map((a, index) => ({
            id: index,
            protheusId: a.id,
            name: a.name,
            description: a.description,
            documentKey: a.documentkey,
            type: 'file',
            code: 200,
            status: 'exist',
            labelStatus: this.literals?.str0192
          }));
          this.menuService.loading(false);
        },
        error: (error) => {
          this.menuService.loading(false);
          this.poNotification.error(this.utils.getErrorMessage(error));
        }
      });
  }

  // ------------------------------------------------------------------ //
  // Ações da lista (download / exclusão)
  // ------------------------------------------------------------------ //

  //-- Dentro do Protheus qualquer ação sobre um anexo abre o banco de
  //-- conhecimento (é lá que se baixa/exclui). Fora, faz o download HTTP.
  downloadDocument(attachment) {
    if (this.isProtheusAttach) {
      this.attachViaProtheus();
      return;
    }

    this.menuService.loading(true);

    this.attachDocumentsService.downloadAttachment(attachment.protheusId)
      .subscribe(response => {
        this.menuService.loading(false);
        const byteString = atob(response['file']);

        const aBuffer = new ArrayBuffer(byteString.length);
        const iArray = new Uint8Array(aBuffer);

        for (let i = 0; i < byteString.length; i++) {
          iArray[i] = byteString.charCodeAt(i);
        }

        const file = new Blob([iArray]);

        const element = document.createElement('a');
        document.body.appendChild(element);
        element.setAttribute('href', window.URL.createObjectURL(file));
        element.setAttribute('download', attachment.name.trim());
        element.click();
      }, error => {
        this.poNotification.error(this.utils.getErrorMessage(error));
        this.menuService.loading(false);
      });
  }

  //-- Dentro do Protheus a exclusão também é feita pela tela nativa. Fora,
  //-- remove item em fila ou confirma a exclusão do anexo persistido.
  cancelUpload(index: number) {
    if (this.isProtheusAttach) {
      this.attachViaProtheus();
      return;
    }

    const currentFile = this.labelsToUpload[index];
    const indexToUp = this.filesToUpload.findIndex(f => f.id === currentFile.id);
    if (currentFile.status === 'waiting' || currentFile.status === 'fail') {
      this.labelsToUpload.splice(index, 1);
      this.filesToUpload.splice(indexToUp, 1);
    } else if (currentFile.status === 'success' || currentFile.status === 'exist') {
      this.thfDialogService.confirm({
        title: this.literals?.str0193,
        message: this.poI18n.transform(this.literals?.str0194, currentFile.name),
        confirm: () => this.deleteDocument(currentFile.name, currentFile.protheusId, index)
      });
    }
  }

  deleteDocument(nameToDelete: string, idToDelete: string, index: number) {
    const body = {
      "document": idToDelete,
      "documentKey": this.labelsToUpload[index].documentKey,
      "table": this.table
    }
    this.menuService.loading(true);
    this.labelsToUpload[index].status = 'loading';
    this.labelsToUpload[index].labelStatus = this.literals?.str0195;
    this.disableDelete = true;
    this.attachDocumentsService.deleteAttachment(body)
      .subscribe(response => {
        this.labelsToUpload.splice(index, 1);
        this.temporaryStorageService.setValue('hasAttachment', !!this.labelsToUpload.length);
        this.disableDelete = false;
        this.menuService.loading(false);
        this.uploadSucess.emit();
        this.poNotification.success(this.poI18n.transform(this.literals?.str0196, nameToDelete));
      }, (error) => {
        this.poNotification.error(this.utils.getErrorMessage(error));
        this.menuService.loading(false);
      });
  }

  // ------------------------------------------------------------------ //
  // Fluxo web original (seleção/arraste/upload HTTP)
  // ------------------------------------------------------------------ //

  onFileChange(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length > 0) {
      const files = Array.from(input?.files || []);
      const uniqueFiles: File[] = [];
      const fileIds: Set<string> = new Set();

      for (const file of files) {
        const fileId = `${file.name}_${file.size}`; // Cria um ID único para o arquivo

        if (!fileIds.has(fileId)) { // Verifica se o ID já existe
          uniqueFiles.push(file);
          fileIds.add(fileId); // Adiciona o ID do arquivo ao conjunto para evitar duplicatas
        }
      }

      // Limpa o valor do input de arquivo para que o evento onchange seja acionado na próxima seleção
      input.value = '';

      if (this.addFilesToLists(uniqueFiles)) {
        this.uploadFiles();
      }
    }
  }

  uploadFiles() {
    this.menuService.loading(true);
    this.disableUpload = true;
    const fileToUpload = this.filesToUpload[0];
    this.filesToUpload = this.filesToUpload.slice(1, this.filesToUpload.length);
    const onGoingId = this.labelsToUpload.findIndex( lblToUp => JSON.stringify(lblToUp) === JSON.stringify(fileToUpload));
    this.labelsToUpload[onGoingId].status = 'loading';
    this.labelsToUpload[onGoingId].labelStatus = this.literals?.str0190;

    if (!this.table) {
      this.table = 'DHU';
    }

    const reader = new FileReader();
    reader.onload = () => {
      const fileB64 = {
        name: fileToUpload.name,
        description: fileToUpload.name,
        content: reader.result.toString().split(',')[1] || '',
        key: this.temporaryStorageService.getValue('quotationCode'),
        table: this.table
      };

      this.attachDocumentsService.postAttachment(fileB64)
      .subscribe(response => {
        this.labelsToUpload[onGoingId].code = response['code'];
        this.labelsToUpload[onGoingId].protheusId = response['id'];
        this.labelsToUpload[onGoingId].documentKey = response['key'];
        this.temporaryStorageService.setValue('hasAttachment', true);
        this.uploadSucess.emit();
        this.poNotification.success(response.message);
        this.menuService.loading(false);
      }, error => {
        this.labelsToUpload[onGoingId].status = 'fail';
        this.labelsToUpload[onGoingId].labelStatus = this.literals?.str0191;
        this.labelsToUpload[onGoingId].code = 400;
        this.poNotification.error(this.utils.getErrorMessage(error));
        this.processNextUpload();
      }, () => {
        this.labelsToUpload[onGoingId].status = 'success';
        this.labelsToUpload[onGoingId].labelStatus = this.literals?.str0192;
        this.processNextUpload();
      });
    };
    reader.readAsDataURL(fileToUpload);
  }

  //-- Processa o próximo arquivo pendente ou reabilita o botão de upload.
  private processNextUpload(): void {
    this.menuService.loading(false);

    if (this.filesToUpload.length) {
      this.uploadFiles();
    } else {
      this.disableUpload = false;
    }
  }

  addFilesToLists(files): boolean {
    this.disableUpload = false;
    let ok = true;
    let id;
    _.remove(files, f => {
      if (f.type === '') {
        this.poNotification.warning(this.poI18n.transform(this.literals?.str0197, f.name));
        ok = false;
        return true;
      } else if (f.size > 10000000) {
        this.poNotification.warning(this.poI18n.transform(this.literals?.str0198, f.name));
        ok = false;
        return true;
      }
    });

    if (this.labelsToUpload.length) {
      id = this.labelsToUpload[this.labelsToUpload.length - 1].id + 1;

      files.forEach(f => {
        f.id = id++;
      });

      this.filesToUpload.push(...files);
      this.labelsToUpload.push(...files);

      this.filesToUpload.forEach(f => {
        f.status = 'waiting';
        f.labelStatus = this.literals?.str0199;
      });
    } else {
      this.filesToUpload = Array.from(files);
      this.labelsToUpload = Array.from(files);

      id = 0;
      this.labelsToUpload.forEach(f => {
        f.id = id++;
        f.status = 'waiting';
        f.labelStatus = this.literals?.str0199;
      });

      id = 0;
      this.filesToUpload.forEach(f => {
        f.id = id++;
      });
    }

    return ok;
  }

  drop(e) {
    e.preventDefault();
    this.isHovering = false;

    //-- Dentro do Protheus o arraste local não se aplica; abre o banco de
    //-- conhecimento, como no clique.
    if (this.isProtheusAttach) {
      this.attachViaProtheus();
      return;
    }

    const files =  Array.from(e.dataTransfer.files);
    if (files && files.length > 0) {
      if (this.addFilesToLists(files)){
        this.uploadFiles()
      }
    }
  }

  allowDrop(e) {
    e.preventDefault();
    this.isHovering = true;
  }

  dragEnter(e) {
    this.isHovering = true;
  }

  dragLeave(e) {
    this.isHovering = false;
  }

  openFileDialog() {
    const fileButtonHandler: HTMLElement = document.getElementById('fileButton') as HTMLElement;
    fileButtonHandler.click();
  }

  getIconStatus(status: string) {
    switch (status) {
      case 'waiting':
        return 'an an-clock';
      case 'loading':
        return 'an an-arrows-clockwise spin-uploading';
      case 'success':
        return 'an an-check';
      case 'fail':
        return 'an an-x';
    }
  }

  getIconFromStatus(fileType: string) {
    const type = fileType.split('/')[0];
    return type === 'image' ? 'an an-image' : 'an an-file';
  }
}
